export const eduData = [
  // Dummy Images, replace with actual IGEM content
  {
    title: "UNESCO",
    image: "https://static.igem.wiki/teams/4260/wiki/education/unesco.png",
    description:
      "She pointed out improvements for our project, one to create a more participative citizenship and to involve them in a more sustainable society. Two, Inspire younger generations by showing them how we manage to build our project and to make their ideas pass from paper to reality. In regard to the observations, we gave conferences and seminars for the community to understand the problem with microplastics and EDCs, to present our project and the achievements through the year.",
  },
  {
    title: "CONFERENCE “WHAT ARE MICROPLASTICS AND HOW DO THEY AFFECT ME?",
    image:
      "https://static.igem.wiki/teams/4260/wiki/education/edu-conferencia-1.png",
    description:
      "Attending the lack of information around micro plastics and its effects in people's health, as we ingest around 50,000 plastic particles per year, we gave a conference inside our institution (Tecnológico de Monterrey, campus Estado de México) where other students and parents were exposed about what microplastics are, where they can be found, how consumption is reduced, likewise, the term EDCs and their effects on health were presented. For this conference we had around 20 attendants from the School of Engineering and Science.",
  },
  {
    title: "RESEARCH SEMINARS",
    image: "https://static.igem.wiki/teams/4260/wiki/education/edu-safety.png",
    description:
      "The Bioengineering Department of ITESM CEM developed a series of research seminars aimed at students of the school of Engineering and Sciences in order to promote the interest in investigation, exchange professional opinions and knowledge. iGEM TecCEM was present, giving an overview of our safety project. ",
  },
  {
    title: "RESEARCH SEMINARS",
    image: "https://static.igem.wiki/teams/4260/wiki/education/edu-meetup-biosensor-1.png",
    description:
      "Also iGEM TecCEM presented in the seminars about the Design of a biosensor for the detection of EDCs",
  },
  {
    title: "RESEARCH SEMINARS",
    image: "https://static.igem.wiki/teams/4260/wiki/education/edu-seminario-mire.png",
    description:
      "Finally, iGEM TecCEM presented in the seminars the design of a degradation system for EDCs.",
  },
  {
    title: "LAB TOURS",
    image: "https://static.igem.wiki/teams/4260/wiki/education/edu-labtour.png",
    description:
      "We understand how difficult a science career path can be, therefore we wanted to motivate high school students and freshman to persist and fall in love with science. We gave them tours in their future laboratories and the use of them focusing on synthetic biology.",
  },

  {
    title: "INTERNATIONAL CONGRESS OF THE BIOTECHNOLOGY CENTER FEMSA",
    image:
      "https://static.igem.wiki/teams/4260/wiki/education/edu-poster2.png",
    description:
      "The IGEM TecCEM biosafety team was accepted to participated in the International Congress of the FEMSA Biotechnology Center in the synthetic biology category, a poster was delivered and exposed (which can be found here) about the use of Isoeugenol as an alternative selection marker for the substitution of antibiotics. The congress was held from August 24th-26th, where the attending public had a great interest in the subject.",
  },
  {
    title: "MEET UP WORKSHOPS",
    image: "https://static.igem.wiki/teams/4260/wiki/education/meetup1-insta.png",
    description:
      "Last August 1st, 2nd and 3th iGEM TecCEM hosted the Hispanic Meet Up where besides the exposition of other iGEM Teams’ projects, we offer nine workshops to the general public related to STEAM activities. We had an attendance of around 60 people per workshop. Thanks to all of these workshops given through these three days, we were able to bring the STEAM activities closer to people, in addition to implementing actions aligned with the of the UN 2030 Sustainable Development Goals. So we act as intermediaries between the specialized scientific community and general population.",
  },
  {
    title: "Biomaterials workshop",
    image: "https://static.igem.wiki/teams/4260/wiki/education/evidencias-meetup-4-3.png",
    description:
      "Given by the professor in bioengineering, PhD. María Guadalupe Pérez, where the public learns how to make new fungi-based materials.",
  },
  {
    title: "Bioart workshop",
    image: "https://static.igem.wiki/teams/4260/wiki/education/evidencias-meetup-1-6.png",
    description:
      " Given by the professor in bioengineering, PhD. Ana Laura Huerta, where people learned to paint using colored and fluorescent proteins.",
  },
  {
    title: "Python 101 workshop",
    image: "https://static.igem.wiki/teams/4260/wiki/education/evidencias-meetuppy1.png",
    description:
      "Given by our software developer,  Humberto Carillo, where he taught the basics of python.",
  },
  {
    title: "How to make your own cheese? workshop",
    image: "https://static.igem.wiki/teams/4260/wiki/education/evidencias-meetup-2-2.png",
    description:
      "Given by the laboratorist in biotechnology, Biologist Ramón Rivero, who shared the process for homemade cheese.",
  },
  {
    title: "Molecular Docking workshop",
    image: "https://static.igem.wiki/teams/4260/wiki/education/evidencias-meetupw1.png",
    description:
      "Given by the laboratorist in biotechnology, Biologist Ramón Rivero, who shared the process for homemade cheese.",
  },
  {
    title: "Micropropagation of violets and orchids workshop",
    image: "https://static.igem.wiki/teams/4260/wiki/education/evidencias-meetupo3.png",
    description:
      "Given by the professor in bioengineering, PhD. Elías Gómez, from whom we learned how to plant and take care of these beautiful flowers.",
  },
  {
    title: "Art with natural pigments workshop",
    image: "https://static.igem.wiki/teams/4260/wiki/education/evidencias-meetuppi3.png",
    description:
      "Given by the professor in bioengineering, PhD. Aurora Antonio, where the public was able to create natural and eco-friendly watercolors",
  },
  {
    title: "Dual Use workshop",
    image: "https://static.igem.wiki/teams/4260/wiki/education/evidencias-meetupd2.png",
    description:
      "given by the iGEM Safe and Security team who explained about the two positive or negative ways in which a new synthetic biology technology can be used and what must be taken into account before sharing it all around the world. We learnt new concepts and to analyze our project from different perspectives. ",
  },
  {
    title: "IGEM World Environment Day with Stockholm",
    image:
      "https://static.igem.wiki/teams/4260/wiki/education/edu-webinar-stockholm-1.png",
    description:
      "IGEM TecCEM participated in this webinar organized by iGEM where the topic was Synthetic Biology: a bold choice for a healthy planet?, in which we have the opportunity to spoke about the negative effects of EDCs and the problems faced today by the rampant use of antibiotics. In both talks, conversation was allowed among the webinar attendees in order to empathize with the problem, as well as to know the positive and negative side that synthetic biology plays."
  },
  {
    title: "Colouring book",
    image:
      "https://static.igem.wiki/teams/4260/wiki/education/edu-libro-1.png",
    description:
      "As scientists we need to relate to younger generations, sometimes thinking synthetic biology is a complex topic to be understood by children. But they are the future and involve children, and awaken interest in science, and we did it with something they surely are interested in, coloring and drawing. The book is planned to be distributed through several schools at no cost, and it has already been shared repeatedly on social networks.",
  },
  {
    title: "Scientific workshop for girls",
    image:
      "https://static.igem.wiki/teams/4260/wiki/education/edu-taller-ninas.png",
    description:
      "Through the invitation of the group My First Day as a Scientist IGEM TecCEM had the opportunity to participate in a 3 day workshop where basic concepts of chemistry were taught to 40 young girls of different ages.",
  },
  {
    title: "Sustainable development goals and synthetic biology",
    image:
      "https://static.igem.wiki/teams/4260/wiki/education/brencalses.jpg",
    description:
      "Finally, there was the opportunity to teach elementary and middle school students in order to share knowledge about the sustainable development goals  and how synthetic biology contributes to their fulfillment. This class was planned to take 30 minutes and the syllabus changed according to the academic level.  To see the complete syllabus click on the button named <i>HERE</i> located in the lower left corner" ,
  },
  {
    title: "Sustainable development goals and synthetic biology 2",
    image:
      "https://static.igem.wiki/teams/4260/wiki/education/sergioclases.jpg",
    description:
      "AND……Another picture teaching middle school students about SDGs and synthetic biology.",
  },
];